import React, { Component } from "react";
import { observer } from "mobx-react";
import { Menu, Container } from "semantic-ui-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

@observer
class CustomerPortalMenu extends Component {
  render() {
    const { activeItem, changeActiveItemCallback, pages, t } = this.props;
    return (
      <>
        <Container>
          <Menu inverted pointing secondary style={{ border: "none" }}>
            {pages.length > 0
              ? pages.map(page => (
                  <Menu.Item
                    style={{ fontSize: "20px" }}
                    key={page.isToursPage ? "tours" : page.pageId}
                    name={page.isToursPage ? t("customerPortal:myTours") : page.title}
                    active={activeItem === (page.isToursPage ? "tours" : page.slug)}
                    onClick={() => changeActiveItemCallback(page.isToursPage ? "tours" : page.slug)}
                  >
                    {page.isToursPage ? t("customerPortal:myTours") : page.title}
                  </Menu.Item>
                ))
              : null}
          </Menu>
        </Container>
      </>
    );
  }
}

CustomerPortalMenu.propTypes = {
  activeItem: PropTypes.string.isRequired,
  changeActiveItemCallback: PropTypes.func.isRequired,
  pages: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CustomerPortalMenu);
